import React, { useCallback } from 'react';
import { Icon } from '@shakkerai/components';
import { translate } from '@shakkerai/util-i18n';
import { useTempState } from '@starflow/app/store';
import { CustomModelCard, PresetModelCard } from '@starflow/app/modules/generator/components/_legacy/model';
import { pickCheckpoint } from '../../../models/helpers';

export const Checkpoint = React.memo((props) => {
  const { title, name, value, onChange } = props;

  const handlePickModel = useCallback(() => {
    pickCheckpoint(value, `model-pick-button-${name}`, (modelData) => {
      onChange(modelData, name);
    });
  }, [value, name, onChange]);

  return (
    <div data-trigger-window="model-checkpoints" id={`model-pick-button-${name}`}>
      <div className="mb-1">
        <span className="text-xs text-[#7f7f7f] leading-[14px]">{title}</span>
      </div>
      {value ? (
        value.error ? (
          <div
            onClick={handlePickModel}
            className="flex items-center justify-center h-[50px] bg-[#f4f6f8] hover:bg-[#f0f2f4] rounded cursor-pointer"
          >
            <span className="text-xs text-amber-600">{`${value.error}`}</span>
          </div>
        ) : (
          <div onClick={handlePickModel} className="cursor-pointer">
            {value.presetId ? <PresetModelCard id={value.presetId} /> : <CustomModelCard data={value} />}
          </div>
        )
      ) : (
        <div
          onClick={handlePickModel}
          className="flex items-center justify-center h-[50px] bg-[#f4f6f8] hover:bg-[#f0f2f4] rounded cursor-pointer"
        >
          <Icon className="shk-zoomin" fontSize={18} color="#444" />
          <span className="ml-1 text-xs text-[#444] font-semibold translate-y-[0.5px]">
            {translate('workflow_model_picker')}
          </span>
        </div>
      )}
    </div>
  );
});

export const CheckpointView = React.memo(({ value }) => {
  const isSimple = useTempState('globalMode') === 'simple';
  const presetId = value.presetId;

  return (
    <>
      <div className="p-4">
        <div className="flex justify-between items-center mb-2">
          <h5 id="model-checkpoints-entry" className="text-[#2d2d2d] text-xs leading-[14px] font-bold font-gro">
            {translate('model_title_checkpoint')}
            <span className="text-[#b2b2b2]">&ensp;Checkpoint</span>
          </h5>
        </div>
        {presetId ? (
          <PresetModelCard id={presetId} readonly={true} />
        ) : (
          <CustomModelCard data={{ ...value }} readonly={true} isSimpleMode={isSimple} />
        )}
      </div>
      <div className="border-t border-[#efefef]" />
    </>
  );
});
